import { render, staticRenderFns } from "./BillingVirtualBJB.vue?vue&type=template&id=46db274a"
import script from "./BillingVirtualBJB.vue?vue&type=script&lang=js"
export * from "./BillingVirtualBJB.vue?vue&type=script&lang=js"
import style0 from "./BillingVirtualBJB.vue?vue&type=style&index=0&id=46db274a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports